const INTERNAL_ERROR_TOKEN = /^(?:[a-z0-9]+_)+[a-z0-9]+$/;
const INTERNAL_DIAGNOSTIC = /(?:sql|postgres|constraint|relation|column|stripe|dialpad|google).*(?:error|failed|failure|code|secret|token|\bid\b|not[_\s-]?found)/i;

export function safeApiErrorMessage(payload, fallback = "Request failed. Please try again.") {
  if (payload?.error === "appointment_delete_protected_evidence" && Array.isArray(payload.blockers)) {
    const reasons = {
      clinical_note: "a retained clinical note exists",
      attendance: "attendance has already been recorded",
      attendance_correction: "an attendance correction exists",
      contact_note: "a Contact Note exists",
      payment: "payment activity exists", claim: "claim activity exists",
      invoice: "invoice activity exists", receipt: "a receipt exists",
      superbill: "a superbill exists", package_usage: "package usage exists",
      financial_event: "financial activity exists",
      completed_paperwork: "protected paperwork exists",
      supervision_review: "supervision review evidence exists",
      group_authority: "this occurrence belongs to the protected group scheduling workflow",
      group_note: "a group note exists", missed_review: "a missed-appointment review exists",
      operational_task: "a linked operational task exists",
      cancellation_request: "a cancellation request exists",
      reschedule_request: "a rescheduling request exists",
    };
    const known = [...new Set(payload.blockers.filter(key => Object.hasOwn(reasons, key)).map(key => reasons[key]))];
    if (known.length) return `Appointment cannot be deleted because ${known.join("; ")}. Review the linked records before proceeding.`;
  }
  const message = typeof payload === "object" && payload !== null && "message" in payload
    ? String(payload.message || "").trim()
    : "";
  if (!message || INTERNAL_ERROR_TOKEN.test(message) || INTERNAL_DIAGNOSTIC.test(message)) return fallback;
  return message;
}
